import {useAppState} from "@/store";
import {apiUrl, dataLayerPush, dateParts, formatPrice, scrollToElement} from "@/helpers";
import {useApi} from "@/api";
import {API_ENDPOINTS} from "@/constants";
import {toast} from "react-toastify";

export default function BookingBar({goToStep}) {
    const {state, setState} = useAppState()
    const {api, loading, setLoading} = useApi()

    const handleSubmit = async () => {
        setLoading(true)
        try {
            const response = await api.post(apiUrl(API_ENDPOINTS.reservation), {
                "requestId": state.requestId,
                "availabilityId": state.availability._id,
                "time": state.chosen_time.time,
                "reservation": {
                    "date": state.chosen_date.raw,
                    "time": state.chosen_time.time,
                    "duration": state.estimate.duration,
                    "slots": state.chosen_time.slots
                }
                // "quoteId": state.chosen_quote
            })

            await dataLayerPush('book-estimate-submit', {
                ['book-estimate-selected-amount']: Math.min(state.availability?.price, state.availability?.salePrice),
                ['book-estimate-selected-date']: state.chosen_date?.raw || null,
                ['book-estimate-selected-time']: state.chosen_time?.time || null,
                ['book-estimate-selected-movers']: state.estimate?.movers || 0,
                ['book-estimate-selected-hours']: state.estimate?.totalTime || 0,
                ['book-estimate-selected-trucks']: state.estimate?.trucks || 0,
                ['book-estimate-selected-trip-fees']: state.estimate?.tripFees || 0,
                ['book-assigned-branch']: state.branch?.name || null,
                ['book-estimate-id']: state.customerId || null,
            })

            goToStep(6)
        } catch (e) {
            toast.error(e.message)

        }
        setLoading(false)
    }

    const inestimable = Object.values(state.inestimable).some(i => !!i)

    if (inestimable) {
        return
    }

    function ChosenDateTime() {
        const date = state.chosen_date && dateParts(state.chosen_date.raw, "long")

        if (state.chosen_date && state.chosen_time) {
            return (
                <span className={"font-bold"}>{date.weekday}, {date.month} {date.day} @ {state.chosen_time?.time}</span>
                // <span className={"font-bold"}>{date.weekday}, {date.month} {date.day} ({state.chosen_time})</span>
            )
        }

        return (
            <>
                {state.chosen_date ? (
                    <span className={"font-bold"}>{date.weekday}, {date.month} {date.day}</span>
                ) : (
                    <button className={"ein-btn-plain !text-red"} onClick={() => scrollToElement(state.timeSelectEl)}>Choose Date</button>
                )}
                {` | `}
                <button className={"ein-btn-plain !text-red"} onClick={() => scrollToElement(state.timeSelectEl)}>Select Time</button>
            </>
        )
    }

    return (
        <div className={"fixed bottom-0 left-0 w-full py-[16px] lg:y-[32px] bg-ice-grey z-[10000] text-[16px] leading-[24px] lg:text-[20px] lg:leading-[32px]"}>
            <div className={"container mx-auto px-[16px] lg:px-[112px] lg:flex lg:justify-between lg:items-center"}>
                <div className={"flex items-center justify-center text-brand-blue space-x-[8px]"}>
                    <div className={"text-brand-blue"}>
                        <ChosenDateTime/>
                    </div>
                    {state.chosen_rate && (
                        <div className={"font-bold"}>
                            &bull; <span className="text-steel-grey">{formatPrice(state.chosen_rate)}</span>
                        </div>
                    )}
                </div>

                <div className={"text-brand-grey font-normal text-center lg:text-left lg:flex lg:justify-between lg:items-center lg:space-x-[32px]"}>
                    <div className={"mt-[8px] lg:mt-0"}>
                        ✅ No deposit &nbsp; ✅ Free cancellation
                    </div>
                    <button
                        className={'ein-btn shadow-btn mt-[8px] lg:mt-0'} disabled={!state.chosen_date || !state.chosen_time || loading}
                        onClick={handleSubmit}
                    >
                        Review + Book
                    </button>
                </div>
            </div>
        </div>
    )
}
